import Image1 from "./assets/analytics.gif"
import Image2 from "./assets/deeplearn.gif"
import Image3 from "./assets/pizzaapp.gif"
import Image4 from "./assets/weatherapp.gif"


export const projects = [
    {
      title: "Zomato Data Analysis",
      subtitle: "Exploratory Data Analysis",
      description:
        "Unlocking Zomato's Data: Dive into our EDA project to analyze and unearth valuable insights and trends, revealing the untapped potential within the data.",
      image: Image1,
      link: "https://github.com/rajproCDE/Exploratory-Data-Analysis-Big-Data-on-Zomato-Dataset",
    },
    {
      title: "Potato Leaf Disease Classification",
      subtitle: "Deep Learning and Python",
      description:
        "Developing a CNN-based Deep Learning model to classify diseases in potato plants. Trained on a diverse dataset of potato plant images, including healthy and infected plants.",
      image: Image2,
      link: "https://github.com/rajproCDE/Potato-Leaf-Disease-Classification",
    },
    {
      title: "Food Delivery App",
      subtitle: "Flutter and Firebase",
      description:
        "Our Pizza Delivery App lets you conveniently browse a wide range of mouthwatering pizzas, customize toppings, and have them delivered right to your doorstep. Enjoy the ultimate pizza experience with just a few taps!",
      image: Image3,
      link: "https://github.com/rajproCDE/Flutter-Food-App-using-Dart",
    },
    {
      title: "Weather Web Application",
      subtitle: "NodeJs and ExpressJs",
      description:
        "Our Node.js and Express.js Weather App provides real-time weather information for any location. Easily access current conditions, forecasts, and more with a user-friendly interface. Stay informed about the weather with our simple yet powerful application.",
      image: Image4,
      link: "https://github.com/rajproCDE/Weather-Web-Application-using-Weather-Api-NodeJs-and-Express",
    },
  ];
  export const skills=[
    "JavaScript",
    "React.js",
    "Node.js",
    "HTML",
    "CSS",
    "Python",
    "MongoDB",
    "Git",
    "UI/UX Design",
    "RESTful APIs",
  ];

export const testimonials=[
  {
    quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eget quam nisi. Fusce sit amet dui vel dui fermentum luctus.",
    image: "path/to/image1.jpg", // Replace with the actual image path
    name: "John Doe",
    company: "ABC Company",
  },
  {
    quote: "In et justo ac nisi convallis venenatis vitae vel felis. Nulla vitae dapibus dui.",
    image: "path/to/image2.jpg", // Replace with the actual image path
    name: "Jane Smith",
    company: "XYZ Corporation",
  },
  {
    quote: "Praesent semper mi a felis aliquet hendrerit. Suspendisse porttitor justo id tellus cursus, sit amet malesuada nisi tincidunt.",
    image: "path/to/image3.jpg", // Replace with the actual image path
    name: "Mike Johnson",
    company: "123 Industries",
  },
];
